import { render, staticRenderFns } from "./TrophyIcon.vue?vue&type=template&id=1f43c413&scoped=true&"
import script from "./TrophyIcon.vue?vue&type=script&lang=js&"
export * from "./TrophyIcon.vue?vue&type=script&lang=js&"
import style0 from "./TrophyIcon.vue?vue&type=style&index=0&id=1f43c413&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1f43c413",
  null
  
)

export default component.exports